/** Bodhini wordmark + flame mark — matches favicon and app sidebar. */

const FLAME_PATH =
  'M12 2c1.1 3.2 4.2 4.4 4.2 8.3a4.2 4.2 0 1 1-8.4 0c0-1.8.9-3 1.9-4-1.9 1-3.6 2.9-3.6 5.9a6.3 6.3 0 0 0 12.6 0c0-5.4-4.4-7.6-6.7-10.1Z';

export function BodhiniMark({
  size = 24,
  gradientId = 'bodhiniFlame',
}: {
  size?: number;
  gradientId?: string;
}) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden>
      <defs>
        <linearGradient id={gradientId} x1="12" y1="2" x2="12" y2="22" gradientUnits="userSpaceOnUse">
          <stop stopColor="#F5B731" />
          <stop offset="1" stopColor="#E0982E" />
        </linearGradient>
      </defs>
      <path d={FLAME_PATH} fill={`url(#${gradientId})`} />
    </svg>
  );
}

export function BodhiniLogo({
  markSize = 24,
  wordmarkClassName = '',
  gradientId = 'bodhiniFlame',
  onDark = false,
}: {
  markSize?: number;
  wordmarkClassName?: string;
  gradientId?: string;
  /** Light wordmark on dark panels (login hero). */
  onDark?: boolean;
}) {
  return (
    <span className="inline-flex items-center gap-2.5 min-w-0">
      <BodhiniMark size={markSize} gradientId={gradientId} />
      <span
        style={{ fontFamily: "'Spectral', serif" }}
        className={
          wordmarkClassName
          || (onDark
            ? 'text-[19px] font-semibold tracking-tight text-white/92 truncate'
            : 'text-[19px] font-semibold tracking-tight text-fg truncate')
        }
      >
        Bodhini
      </span>
    </span>
  );
}
